module.exports = __webpack_public_path__ + "media/images/donation/logo-au-2f0fff62ab8a0ba832a0a21238386165.jpg";